export const ROUTES = {
  SOLO: "/",
  SOLO_PLAY: "/play/:gameRules",
  TWITCH: "/twitch",
  TWITCH_PLAY: "/twitch/:channel/play/:gameRules",
};
